export default "__VITE_ASSET__Dj5sOw4V__"